import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useAnchor } from 'shared/hooks/utils';
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import IndicatorService from './icons/service.svg';
import IndicatorSensors from './icons/sensor.svg';
import { ServiceSensorsSettingsMenu } from './menu';
export const ServiceSensorsSettings = memo(function ServiceSensorsSettings(props) {
    const { service_notification, sensors_notification, onSetServiceMode, onChangeSilentMode, silent_mode, } = props;
    const [menu_anchor, openMenu, closeMenu] = useAnchor();
    return (_jsxs(_Fragment, { children: [_jsx(Tooltip, { title: sensors_notification
                    ? 'Не все датчики активны'
                    : 'Режим сервиса и настройка датчиков', children: _jsx(IconButton, { onClick: openMenu, size: "large", color: service_notification ? 'warning' : 'neutral', sx: { px: 0 }, children: _jsx(ResponsiveIcon, { Icon: !sensors_notification ? IndicatorService : IndicatorSensors }) }) }), _jsx(ServiceSensorsSettingsMenu, { onSetServiceMode: onSetServiceMode, onChangeSilentMode: onChangeSilentMode, silent_mode: silent_mode, anchor: menu_anchor, onClose: closeMenu })] }));
});
